import React, { useCallback, useEffect, useRef, useState } from 'react'
import Grid from '@mui/material/Grid2';
import "./knowledge.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNavigate, useParams } from 'react-router-dom';
import { faUser } from '@fortawesome/free-regular-svg-icons';
import { apiService } from '../../services/apiService';
import { toast } from 'react-toastify';
import KnowledgeHead from '../../components/header/KnowledgeHead';
import ExportPdfModal from '../../components/exportkba/ExportPdfModal';
import { exportToPDF } from '../../components/exportkba/usePdfExport';
import { faFilePdf } from "@fortawesome/free-solid-svg-icons";

function KnowledgeViewLogout() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [isRestrict, setIsRestrict] = useState(false);
    const [retireShow, setRetireShow] = useState(false);
    const [previewData, setPreviewData] = useState([]);
    const { slug } = useParams();
    const [docudatas, setDocumentdatas] = useState([]);
    const token = localStorage.getItem('token');

    const printRef    = useRef(null);
    const [modalOpen,  setModalOpen]  = useState(false);
    const [exportMode, setExportMode] = useState("pdf");   // "pdf" | "pdf-attach"
    const [exporting,  setExporting]  = useState(false);
    const [exportProg, setExportProg] = useState(0);
    
    
    // ─── STEP 3 ── Add this handler inside your component function ────────────────
    
    const handleExportConfirm = async (selectedDocIds) => {
        if (selectedDocIds === null || selectedDocIds === undefined) return;

        setExporting(true);
        const articleData = previewData?.[0];
        try {
            const result = await exportToPDF({
                article:         articleData,
                articleContent:  articleData?.content ?? "",
                withAttachments: exportMode === "pdf-attach",
                documents:       docudatas?.documents ?? [],
                selectedDocIds,
                onProgress:      setExportProg,
                fileName:        `KBA-${articleData?.format_id ?? "Article"}`,
            });

            if (result === false) return; // ✅ cancelled — skip modal close & toast

            const VEXT = ["mp4","mpeg","webm","ogg","mov","avi","mkv","flv","wmv","m4v","3gp","wav","aac","mp3","flac","x-m4a"];
            const count = (docudatas?.documents ?? []).filter(d =>
                !VEXT.includes((d.extension||"").toLowerCase()) && selectedDocIds.includes(String(d.id))
            ).length;

            setModalOpen(false); // ✅ only closes on success
            toast(exportMode === "pdf-attach"
                ? `✓ PDF + ${count} attachment(s) downloaded`
                : "✓ PDF downloaded"
            );
        } catch (err) {
            console.error("Export failed:", err);
            toast.error("Export failed. Please try again.");
        } finally {
            setExporting(false);
            setExportProg(0);
        }
    };
    
    const fetchPreviewData = useCallback(async () => {
        try {
            const response = await apiService.getRequest(`knowledge-articles/${slug}`);
            if (response && response.success === true) {
                setPreviewData(Array.isArray(response.data) ? response.data : [response.data]);
                setDocumentdatas(response.data);
                setRetireShow(false);
            }else if(response && response.is_retired === true){
                setRetireShow(true);
            }else if(response && response?.error === "permission_denied"){
                setIsRestrict(true);
            }else{
                toast.error(response.message || "Failed to load a Article");
                setRetireShow(false);
                navigate("/knowledge");
            }
        } catch (error) {
            console.error('Error fetching group data:', error);
        } finally {
            setLoading(false);
        }
    }, [slug,navigate]); // Dependency on slug

    // Call fetchPreviewData on mount and whenever slug changes
    useEffect(() => {
        fetchPreviewData();
    }, [fetchPreviewData]);
    
    const sanitizeAndDisplayHTML = (html) => {
        const sanitizedHTML = html
        return sanitizedHTML;
    };
  return (
      <>
      {loading ? 
          <div className='d-flex justify-content-center w-100 mt-5 pt-5'>
              <img style={{ width: "100px" }} src={require('../../assets/pinkloader.gif')} alt='Loading...' />
          </div>:<>
    <KnowledgeHead/>
    {retireShow && retireShow === true ? 
    <div className='container-fluid px-0'>
        <div className='content_container'>
            <Grid size={{xs:12}} container className="main_jobseeker" justifyContent="center" alignItems="center" style={{minHeight:"82vh"}}>
                <Grid size={{md:6,sm:8,xs:10}} container className="retirewarning" flexDirection="column" alignItems="center" justifyContent="center">
                    <img src={require("../../assets/retire_warning.svg").default} alt=''/>
                    <h4>KBA is retired, and is no longer viewable</h4>
                    <span>It has been removed as part of regular content updates to ensure accuracy and relevance.</span>
                    <button className='registersendbtn2 my-2 px-4' onClick={()=>navigate("/knowledge")} style={{width:"max-content"}}>Back to KB Article</button>
                </Grid>
            </Grid>
        </div>
    </div> :isRestrict && isRestrict === true ?
    <div className='container-fluid px-0'>
        <div className={`content_container pt-4 ${!token && "px-5"}`}>
            <Grid size={{xs:12}} container className="main_jobseeker" justifyContent="center" alignItems="center" style={{minHeight:"82vh"}}>
                <Grid size={{md:6,sm:8,xs:10}} container className="retirewarning" flexDirection="column" alignItems="center" justifyContent="center">
                    <img src={require("../../assets/secure_warning.svg").default} alt=''/>
                    <span>You are restricted from viewing the article due to security reasons. If you have any questions regarding the article, please contact your recruiter.</span>
                    {token ? 
                    <button className='registersendbtn2 my-2 px-4' onClick={()=>navigate("/dashboard")} style={{width:"max-content"}}>Dashboard</button>:
                    <button className='registersendbtn2 my-2 px-4' onClick={()=>navigate("/login")} style={{width:"max-content"}}>Login</button>
                    }
                </Grid>
            </Grid>
        </div>
    </div>:
    <div className='container-fluid px-0' style={{overflowX:"hidden"}}>
        <div className='content_container p-3' style={{ flexGrow: 1 }}>
        {previewData && previewData.map((article) => (
            <div key={article.id} className='w-100 overflow-auto'>
            <Grid size={{sm:12}} container className="main_jobseeker" style={{background:"#fff"}}>
                <Grid size={{sm:12}} container alignItems="center">
                    <Grid size={{md:12,xs:12}} container flexDirection="column" className="jobseekerhead">
                        <h3>Knowledge Article</h3>
                    </Grid>
                </Grid>
                <Grid size={{sm:12}} container justifyContent="center" className="mt-lg-4 mt-3">
                    <Grid ref={printRef} size={{sm:12}} container justifyContent="center" className="knowledge_lister">
                        <Grid size={{xs:12}} container justifyContent="space-between" alignItems="flex-start">
                            <span className="formatid_copyclip"
                                onClick={async () => {
                                    const url = `${window.location.origin}/knowledge-article/${article.format_id}`;
                                    const title = article.title || "Knowledge Article";

                                    // Plain text: first line = ID + title, second line = raw URL
                                    const textPlain = `${article.format_id}: ${title}\n${url}`;

                                    // Rich text: clickable anchor
                                    const textHtml = `<a href="${url}" target="_blank">${article.format_id}: ${title}</a>`;

                                    try {
                                    await navigator.clipboard.write([
                                        new ClipboardItem({
                                        "text/html": new Blob([textHtml], { type: "text/html" }),
                                        "text/plain": new Blob([textPlain], { type: "text/plain" }),
                                        }),
                                    ]);
                                    toast("Link copied to clipboard");
                                    } catch (err) {
                                    console.error("Failed to copy: ", err);
                                    toast("Failed to copy link");
                                    }
                                }}
                                >
                                {article.format_id}
                            </span>
                            <div className='d-flex gap-3 flex-wrap'>
                                {article?.is_preview_render === 1 &&
                                <button
                                    onClick={() => { setExportMode("pdf-attach"); setModalOpen(true); }}
                                    style={{
                                    display:"inline-flex", alignItems:"center", gap:7,
                                    padding:"8px 12px", borderRadius:8, border:"none",
                                    background:"#C32A7C",
                                    color:"#fff", fontSize:13, fontWeight:600, cursor:"pointer",
                                    transition:"transform .12s, box-shadow .12s",
                                    }}
                                    onMouseEnter={e => { e.currentTarget.style.transform="translateY(-1px)"; }}
                                    onMouseLeave={e => { e.currentTarget.style.transform="translateY(0)"; }}
                                >
                                    <FontAwesomeIcon icon={faFilePdf} />
                                </button>}
                            </div>
                        </Grid>
                        <h4>{article.title}</h4>
                        <Grid size={{xs:12}} container className="span_griders mb-4">
                            <span><FontAwesomeIcon icon={faUser} className='icon_kn'/><small>Authored by :</small>{article.author.name}</span>
                        </Grid>
                        <Grid size={{xs:12}} container className="gap-3 mb-lg-3">
                            {Array.isArray(docudatas.documents) ? (
                                docudatas.documents.map(docum => (
                                <Grid key={docum.id} size={{lg:2.8,md:2.8,sm:3.8,xs:12}} alignItems="center" container className="documentcards">
                                    {docum && (docum.extension ==="docx" || docum.extension ==="word") ?
                                    <img src={require('../../assets/svg2.svg').default} alt={docum.name} /> : docum && docum.extension ==="pdf" ? <img src={require('../../assets/svg1.svg').default} alt={docum.name} /> : docum && (docum.extension ==="csv" || docum.extension ==="xls" || docum.extension ==="xlsx") ? <img src={require('../../assets/svg4.svg').default} alt={docum.name} /> : <img src={require('../../assets/svg3.svg').default} alt={docum.name}/>
                                    }
                                    <a href={docum.file_path} target="_blank" rel="noopener noreferrer">{docum.document_name}</a>
                                </Grid>
                                ))
                            ) : (
                                ""
                            )}
                        </Grid>
                        <div className='w-100 caliberifontsset mob_videoset' dangerouslySetInnerHTML={{ __html: sanitizeAndDisplayHTML(article.content) }} />
                    </Grid>
                </Grid>
            </Grid>
        </div>
        
        ))}
        </div>
    </div>
    }
    </>}
    <ExportPdfModal
        open={modalOpen}
        mode={exportMode}
        documents={docudatas?.documents ?? []}
        loading={exporting}
        progress={exportProg}
        onClose={() => !exporting && setModalOpen(false)}
        onConfirm={handleExportConfirm}
    />
    </>
  )
}

export default KnowledgeViewLogout
